import { StoreType } from '@/types/infoStep'
import { z } from 'zod'

const offlineCategorySchema = z.number({
  required_error: 'لطفاً دسته‌بندی فروش حضوری را انتخاب کنید',
  invalid_type_error: 'لطفاً دسته‌بندی فروش حضوری را انتخاب کنید'
})

export const createCategorySchema = (storeType?: StoreType | string) => {
  const requiresOnline =
    storeType === StoreType.ONLINE || storeType === StoreType.BOTH
  const requiresOffline =
    storeType === StoreType.PHYSICAL || storeType === StoreType.BOTH
  const isOnlineOnly = storeType === StoreType.ONLINE

  return z.object({
    categoryType: z.enum(['product', 'service'], {
      required_error: 'لطفا یک گزینه را انتخاب کنید'
    }),
    onlineCategories: requiresOnline
      ? isOnlineOnly
        ? z
            .array(z.number())
            .min(1, 'لطفاً یک دسته‌بندی انتخاب کنید')
            .max(1, 'فقط یک دسته‌بندی می‌توانید انتخاب کنید')
        : z.array(z.number()).min(1, 'لطفاً حداقل یک دسته‌بندی انتخاب کنید')
      : z.array(z.number()),
    offlineCategorie: requiresOffline
      ? offlineCategorySchema
      : z.number().nullable()
  })
}
